// src/components/Modal/Modal.js
import React, { useEffect } from "react";
import "./Dialog.css";

export default function Dialog({ open, onClose, children }) {
  const [modalState, setModalState] = React.useState("closed"); // "open" | "closing"

  // Trigger open animation
  useEffect(() => {
    if (open) {
      setTimeout(() => setModalState("open"), 10);
    } else if (modalState === "open") {
      setModalState("closing");
    }
  }, [open]);

  // Remove modal after closing animation
  const handleTransitionEnd = () => {
    if (modalState === "closing") {
      setModalState("closed");
    }
  };

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!open && modalState === "closed") return null;

  return (
    <div className="d-modal-backdrop" onClick={onClose}>
      <div
        className={`modal-content ${modalState}`}
        onClick={(e) => e.stopPropagation()}
        onTransitionEnd={handleTransitionEnd}
      >
        {children}
      </div>
    </div>
  );
}
